export default __webpack_public_path__ + "static/media/forestly-expl-dissect-base_DE.6609c97e.png";